import * as types from "../types";

export const setFaqLanguage = ({languageCode}) => ({
    type: types.SET_FAQ_LANGUAGE,
    payload:{
        languageCode
    }
})